import { PushOptInDialog } from './PushOptInDialog'

/**
 * `customer-notifications` - asking to be allowed to notify, and nothing else.
 *
 * No routes: the offer renders app-wide, above the router, exactly where legacy's `App.tsx` mounts it.
 * AGOS's first draft rendered it inside the home page, so a customer who landed on `/checkout` or
 * `/moj-profil` was never asked - FB-C13.
 *
 * **A popup since §9.737** (owner O107): a modal dialog on every route until the customer says *Nie*. The
 * registry name stays `push-opt-in`, which `route-diff.test.ts` holds against legacy's list of app-wide surfaces.
 *
 * Whether asking is possible at all is `@agos/customer-core`'s `pushState`: the VAPID key is checked
 * before the browser is (FB-C03), because a subscription without a server key is one the server can
 * never use. Whether to ask now is its `pushPromptOf`.
 */
export const customerNotificationsModule = {
  name: 'customer-notifications',
  banners: [{ name: 'push-opt-in', component: PushOptInDialog }],
} as const

export { PushOptInDialog } from './PushOptInDialog'
export { publicKeyOf } from './push-key'
